export default function buildQuery(obj, page) {
  let query = [];
  if (obj.limit != null) {
    query.push(`$limit=${obj.limit}`);
  } else {
    query.push("$limit=15");
  }
  if (obj.skip) {
    query.push(`$skip=${obj.skip}`);
  } else {
    if (page) {
      query.push(`$skip=${page * (obj.limit || 15)}`);
    } else {
      query.push(`$skip=0`);
    }
  }

  if (obj.columns) {
    obj.columns.forEach((x) => {
      if (x.type === "date-range") {
        if (x.filter.startDate && x.filter.endDate) {
          //create start of the day in strart date and end of the day in end date
          let startDate = new Date(x.filter.startDate);
          startDate.setHours(0, 0, 0, 0);
          let endDate = new Date(x.filter.endDate);
          endDate.setHours(23, 59, 59, 999);

          query.push(`${x.key}[$gte]=${startDate.toISOString()}`);
          query.push(`${x.key}[$lte]=${endDate.toISOString()}`);
        }
      } else if (x.type === "number-range") {
        if (x.filter.min !== null && x.filter.min !== "")
          query.push(`${x.key}[$gte]=${x.filter.min}`);
        if (x.filter.max !== null && x.filter.max !== "")
          query.push(`${x.key}[$lte]=${x.filter.max}`);
        // if (x.filter.min && Number(x.filter.min) === 0) {
        //   query.push(`${x.key}[$exists]=false`);
        // }
      } else {
        const sentinels = (x.excludeValues || []).map((v) =>
          String(v).toLowerCase(),
        );
        const values = (x.filter || []).filter((xx) => xx);
        // The "All" entry is a sentinel, not a value: it means "no constraint on
        // this column". Enumerating the options instead would silently drop rows
        // whose value isn't in the option list (e.g. product status "inactive",
        // or a status a provider sends that we never listed).
        const selectsEverything = values.some((xx) =>
          sentinels.includes(String(xx).toLowerCase()),
        );
        if (!selectsEverything) {
          values.forEach((xx) => {
            query.push(`${x.key}[$in][]=${encodeURIComponent(xx)}`);
          });
        }
        (x.initExcludeValues || []).forEach((xx) => {
          query.push(`${x.key}[$nin][]=${encodeURIComponent(xx)}`);
        });
      }
      if (x.sort) {
        query.push(`$sort[${x.sort_key || x.key}]=${x.sort}`);
      }
    });
  }
  if (obj.populate) {
    obj.populate.forEach((x, index) => {
      if (typeof x === "object" && x.path) {
        let populateStr = `$populate[${index}][path]=${x.path}`;
        if (x.select && Array.isArray(x.select)) {
          x.select.forEach((sel, iii) => {
            populateStr += `&$populate[${index}][select][${iii}]=${sel}`;
          });
        }
        query.push(populateStr);
        return;
      } else {
        query.push(`$populate[${index}][path]=${x}`);
      }
    });
  }
  if (obj.select && Array.isArray(obj.select)) {
    obj.select.forEach((sel, iii) => {
      query.push(`$select[${iii}]=${sel}`);
    });
  }
  return query.join("&");
}

export function buildQueryObject(obj, page) {
  //make the query object and for each element in the object set element with array of values
  let query = {};
  if (obj.limit != null) {
    query.limit = obj.limit;
  } else {
    query.limit = 15;
  }
  if (obj.skip) {
    query.skip = obj.skip;
  } else {
    if (page) {
      query.skip = page * (obj.limit || 15);
    } else {
      query.skip = 0;
    }
  }

  if (obj.columns) {
    obj.columns.forEach((x) => {
      if (x.type === "date-range") {
        if (x.filter.startDate && x.filter.endDate) {
          query[`${x.key}_from`] = x.filter.startDate;
          query[`${x.key}_to`] = x.filter.endDate;
        }
      } else if (x.type === "number-range") {
        if (x.filter.min !== null && x.filter.min !== "")
          query[`${x.key}_from`] = x.filter.min;
        if (x.filter.max !== null && x.filter.max !== "")
          query[`${x.key}_to`] = x.filter.max;
      } else {
        query[x.key] = x.filter;
      }
      if (x.sort) {
        if (!query.sort) query.sort = {};
        query.sort[x.sort_key || x.key] = x.sort;
      }
    });
  }
  return query;
}
